import React,{useEffect,useState} from 'react';
import ListItem from '../components/ListItem';
import Header from '../components/Header';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import '../App.css';


const BlogSidebar=()=>{

  return (
  <>

  <div className="sidebar">
    <h2>Get pre-Approved Today</h2>      
  </div>

    </>
  );
}

export default BlogSidebar;